import { render, staticRenderFns } from "./DetalheTitulo.vue?vue&type=template&id=9817aa6c"
import script from "./DetalheTitulo.vue?vue&type=script&lang=js"
export * from "./DetalheTitulo.vue?vue&type=script&lang=js"
import style0 from "./DetalheTitulo.vue?vue&type=style&index=0&id=9817aa6c&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9817aa6c')) {
      api.createRecord('9817aa6c', component.options)
    } else {
      api.reload('9817aa6c', component.options)
    }
    module.hot.accept("./DetalheTitulo.vue?vue&type=template&id=9817aa6c", function () {
      api.rerender('9817aa6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DetalheTitulo.vue"
export default component.exports